import { useQuery } from '@hooks/reactQuery';

import { getAssetAOVisibilityModes } from '@api/assetAccess';

import { extractQueryParams } from '@utils/common';
import { nameTitleToOptionFormatted } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { EUserRoles } from '@enums/common';

import { ASSET_ACCESS_VISIBILITY_MODES } from '@constants/queryKeys';

interface IUseQueryAccessAccessAoVisibilityModesReturned {
	accessAOVisibilityModes: TSelectOption<string>[];
	isLoadingAccessAOVisibilityModes: boolean;
}

export const useQueryAccessAccessAoVisibilityModes = (): IUseQueryAccessAccessAoVisibilityModesReturned => {
	const {
		data,
		isInitialLoading,
	} = useQuery({
		queryKey: [ASSET_ACCESS_VISIBILITY_MODES],
		allowedRoles: [EUserRoles.platformOwnerAdministrator],
		queryFn: extractQueryParams(getAssetAOVisibilityModes),
		select: (data) => nameTitleToOptionFormatted(data || []),
		refetchOnWindowFocus: false,
	});

	return {
		accessAOVisibilityModes: data || [],
		isLoadingAccessAOVisibilityModes: isInitialLoading,
	};
};
